var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showFixedCta)?_c('div',{staticClass:"fixed-cta"},[_c('div',{staticClass:"fixed-cta__container"},[_c('hot-button',_vm._b({},'hot-button',_vm.button,false),[_vm._v("\n      "+_vm._s(_vm.button.label)+"\n    ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }